<template>
<div>
    <div>
        <b-button class="me-2" variant="light" @click="$eventHub.$emit('navigateBack')">
            <i class="fas fa-arrow-left"></i> Back
        </b-button>
    </div>
    <div v-if="hasMounted">
        <hr>
        
        <b-alert :show="chart_config.length == 0">No User Data Available</b-alert>
        <org-chart v-if="chart_config.length > 0" :level_data="chart_config"/>
    <!--<div id="tree-chart" style="width:100%; "> </div>  height: 600px; -->
    </div>
</div>
    
</template>

<script>
import _ from 'lodash';
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
//import OrgChart from '@/components/widgets/orgChart.vue'
//import OrgChart from '../../widgets/orgChart.vue';
/*import 'treantjs/Treant.css'
import raphael from 'treantjs/vendor/raphael.js'
window.Raphael = raphael;
import 'treantjs';*/
export default {
    data:() => ({
        hasMounted: false,
        chart_config: null,
        chart: null,
    }),
    components:{
        //OrgChart,
    },
    computed:{...ccbAdminState},
    methods:{
        ...ccbAdminMethods,
        loadChartData(){
            this.hasMounted = false;
            let levels = _.cloneDeep(this.client_data.levels);
            this.chart_config = levels;
            this.$nextTick(()=>{
                this.hasMounted = true;
            })

        },
        initChart(){
            this.chart_config = {
                chart: {
                    container: '#tree-chart',
                    connectors:{
                        type: 'step',
                        style:{
                            'stroke-width': 1
                        }
                    },
                    node:{
                        HTMLclass: 'levelNode'
                    },
                },
                nodeStructure: {
                    text: { name: "Parent node", title: "Title" },
                    children: [
                        { text: { name: "First child" } },
                        { text: { name: "Second child" } }
                    ]
                }
            };
            /*
            //eslint-disable-next-line
            this.chart = new Treant(this.chart_config);
            */
        }
    },
    mounted(){
        //this.initChart();
        this.loadChartData();
    },
}
</script>

<style>

</style>